import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=f64f8fca&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f64f8fca')) {
      api.createRecord('f64f8fca', component.options)
    } else {
      api.reload('f64f8fca', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=f64f8fca&", function () {
      api.rerender('f64f8fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zb6z4Q4lHfkU/JS/cancellationPolicy.vue"
export default component.exports